var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// TEAM_TICKET_TYPES
var TEAM_TICKET_TYPES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TeamTicketTypes($id: ID!) {\n    team(id: $id) {\n      id\n      ticket_types {\n        id\n        group {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query TeamTicketTypes($id: ID!) {\n    team(id: $id) {\n      id\n      ticket_types {\n        id\n        group {\n          id\n        }\n      }\n    }\n  }\n"])));
export var useTeamTicketTypesQuery = function (options) { return useQuery(TEAM_TICKET_TYPES, options); };
export default TEAM_TICKET_TYPES;
var templateObject_1;
